/**
 * Authentication hook for Cloudflare Access session state
 */

import { useCallback } from 'react';
import { useAuthStore } from '@store/authStore';
import { authApi } from '@api/auth';

export function useAuth() {
  const { setSession, setNotProvisioned, setLoading, isAuthenticated, user, tenant } = useAuthStore();

  const checkSession = useCallback(async () => {
    setLoading(true);
    try {
      const session = await authApi.getMe();
      setSession(session.user, session.currentTenant, session.permissions);
      if (session.currentTenant) {
        localStorage.setItem('bizops-tenant', session.currentTenant.tenantId);
      }
      return true;
    } catch (error: unknown) {
      const axiosError = error as { response?: { status?: number; data?: { code?: string } } };
      if (axiosError.response?.status === 403 && axiosError.response.data?.code === 'not_provisioned') {
        setNotProvisioned(true);
      }
      return false;
    } finally {
      setLoading(false);
    }
  }, [setLoading, setNotProvisioned, setSession]);

  return {
    checkSession,
    isAuthenticated,
    user,
    tenant,
  };
}
